import apiClient from '@/services/axios'
import qs from 'qs'

export const getTocoProductChannelList = ({ business_id, workspace_id, channel_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/channel/toco/product/query/${channel_id}`,
    headers: {
      'Business-Id': business_id,
      'Workspace-Id': workspace_id,
    },
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
  })
}

export const getLatestTocoProductChannelSyncStatus = ({ channel_id, business_id, workspace_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/toco/product/query/process/sync`,
    headers: {
      'Business-Id': business_id,
      'Workspace-Id': workspace_id,
    },
    params: {
      channel_id,
    },
    data: {
      channel_product_id: [],
    },
  })
}

export const getTocoImportProductStatus = ({ business_id, channel_id, request_id, product_ids }) => {
  const requestIdPath = request_id ? `/${request_id}` : ''
  return apiClient({
    method: 'get',
    url: `/channel/toco/product/query/${channel_id}/import/status${requestIdPath}`,
    headers: {
      'Business-Id': business_id,
    },
    params: {
      product_ids,
    },
  })
}

export const getProductVariantToco = ({ channel_id, business_id, params }) => {
  return apiClient({
    method: 'get',
    url: `channel/toco/product/query/${channel_id}/attributes`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getProductBrandToco = ({ channel_id, business_id, params }) => {
  return apiClient({
    method: 'get',
    url: `channel/toco/product/query/${channel_id}/brand-list`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getWarehouseToco = ({ channel_id, business_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/toco/shop/query/warehouse/list/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getTocoWarehouseChannelList = ({ channel_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/toco/shop/query/warehouse/list/${channel_id}`,
  })
}

export const checkTocoProductSyncStatus = ({ business_id, workspace_id, channel_id, request_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/toco/product/query/sync/${channel_id}/${request_id}`,
    headers: {
      'Business-Id': business_id,
      'Workspace-Id': workspace_id,
    },
    data: { channel_product_id: [] },
  })
}

export const getTocoDetailChannel = ({ business_id, channel_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/toco/shop/query/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const deactivateTocoProductChannel = ({ business_id, channel_id, channel_product_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/toco/product/cmd/${channel_id}/status/deactivate/${channel_product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const activateTocoProductChannel = ({ business_id, channel_id, channel_product_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/toco/product/cmd/${channel_id}/status/activate/${channel_product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const syncTocoSingleProductChannel = ({ business_id, channel_id, product_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/toco/product/cmd/${channel_id}/sync/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const mappingWarehouseTocoChannel = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/channel/toco/shop/cmd/warehouse/map',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const unMappingWarehouseTocoChannel = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/channel/toco/shop/cmd/warehouse/unmap',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const disconnectTocoIntegration = ({ business_id, channel_id }) => {
  return apiClient({
    method: 'put',
    url: '/channel/toco/integration/cmd/disconnect',
    headers: {
      'Business-Id': business_id,
    },
    params: { channel_id },
  })
}

export const updateTocoAutoAcceptPerWarehouse = ({ business_id, channel_id, data }) => {
  return apiClient({
    method: 'put',
    url: `/channel/toco/shop/cmd/${channel_id}/warehouse`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const channelAcceptToco = ({ workspace_id, business_id, user_id, params }) => {
  return apiClient({
    method: 'put',
    url: `/channel/toco/order/cmd/state/channel-accept`,
    params,
  })
}